import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { FiEdit } from 'react-icons/fi';

import { useToast } from '../../../context/ToastContext';

import { Container, Content } from './styles';
import api from '../../../services/api';
import convertNumberFloatToBr from '../../../utils/convertNumberFloatToBr';

import ListingTemplate from '../../../components/Template/Listing';

import { IService, IServiceResponse } from '../../../interfaces/service';

import { IPermission } from '../../../interfaces/permission';
import convertDateStringToDate from '../../../utils/convertDateStringToDate';

interface PermissionDTO {
  permissions: IPermission;
}

const ListServices: React.FC<PermissionDTO> = ({ permissions }) => {
  const { addToast } = useToast();
  const [loading, setLoading] = useState<boolean>(false);
  const [listServices, setListServices] = useState<IService[]>([]);
  const [listServicesPaginated, setListServicesPaginated] = useState<
    IService[]
  >([]);

  useEffect(() => {
    setLoading(true);

    api
      .get<IServiceResponse[]>('services')
      .then(response => {
        const responseFormatted = response.data.map(i => ({
          ...i,
          createdAt: convertDateStringToDate(i.createdAt),
          updatedAt: convertDateStringToDate(i.updatedAt),
        }));

        setListServices(responseFormatted);
        setListServicesPaginated(responseFormatted);

        setLoading(false);
      })
      .catch(error => {
        setLoading(false);

        if (error.response && error.response.data) {
          const { data } = error.response; // Error vindo do back está em data dentro de response
          addToast({
            type: 'error',
            title: data.message,
          });
          return;
        }

        addToast({
          type: 'error',
          title: 'Error',
          description: 'Erro ao listar!',
        });
      });
  }, [addToast]);

  const handleListServicesPaginatedItems = useCallback(newList => {
    setListServicesPaginated(newList);
  }, []);

  return (
    <ListingTemplate
      title="Listagem de Serviços"
      module="services"
      listItemsProps={listServices}
      handleListItemsPaginatedItems={handleListServicesPaginatedItems}
      placeHolderProp="Cód. ou Nome"
      searchTheLocalObject
      disabled={loading}
      permissions={permissions}
    >
      <Container>
        <Content>
          {loading ? (
            <p>carregando ...</p>
          ) : (
            <table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Nome</th>
                  <th>Preço</th>
                  <th>Unidade</th>
                  <th>Localização</th>
                  <th>Observação</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {listServicesPaginated.map(s => (
                  <tr key={String(s.id)}>
                    <td>{s.id}</td>
                    <td>{s.name}</td>
                    <td>{convertNumberFloatToBr(s.price)}</td>
                    <td>{s.unit}</td>
                    <td>{s.localization}</td>
                    <td>{s.observation}</td>
                    <td>
                      {(permissions.update && (
                        <Link to={`/services/update/${s.id}`}>
                          <FiEdit size={16} color="var(--azul-5bits)" />
                        </Link>
                      )) || (
                        <span>
                          <FiEdit size={16} color="var(--cinza-escuro-5bits)" />
                        </span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </Content>
      </Container>
    </ListingTemplate>
  );
};

export default ListServices;
